module.exports = __webpack_public_path__ + "img/90fe8a1.png";